import { FileText, LayoutDashboard, type LucideIcon } from 'lucide-react'

export const PUBLICAR_OBRA_AGENTE_PROMPT =
  'Quiero cotizar mi obra a partir de la documentación que tengo, ¿por dónde empiezo?'

export const ANALIZAR_DOC_OBRA_COTIZACIONES_PROMPT = PUBLICAR_OBRA_AGENTE_PROMPT

export type ConversationalQuickAction = {
  id: string
  label: string
  message: string
  icon: LucideIcon
}

function promoteTargetLabel(userData?: unknown): string {
  let promoteTarget = 'mi presencia'
  if (userData && typeof userData === 'object') {
    const t = (userData as { type?: string }).type
    if (t === 'COMPANY') promoteTarget = 'mi empresa'
    else if (t === 'PERSON') promoteTarget = 'mi perfil profesional'
  }
  return promoteTarget
}

export function getConversationalQuickActions(userData?: unknown): ConversationalQuickAction[] {
  const promoteTarget = promoteTargetLabel(userData)

  return [
    {
      id: 'analyze-docs',
      label: 'Cotizar obra con tu documentación',
      message: PUBLICAR_OBRA_AGENTE_PROMPT,
      icon: FileText
    },
    {
      id: 'my-work',
      label: 'Ofrecer mis servicios/productos',
      message: `Quiero promocionar ${promoteTarget} en Edify, ¿cómo hago?`,
      icon: LayoutDashboard
    }
  ]
}
